import {
  clearApiDetails,
  retrieveApiDetails,
  setupAxiosForApi,
  storeApiDetails,
} from '../utils/api';

export const API_SET = 'api/API_SET';

export const API_CLEARED = 'api/API_CLEARED';

const currentApiDetails = retrieveApiDetails();
const currentURL = currentApiDetails ? currentApiDetails.attributes.url : null;

const initialState = {
  site: currentApiDetails,
  url: currentURL,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case API_SET:
      return {
        ...state,
        url: action.url,
        site: action.site,
      };

    case API_CLEARED:
      return {
        ...state,
        url: null,
        site: null,
      };

    default:
      return state;
  }
};

export const setApi = site => dispatch => {
  dispatch({
    type: API_SET,
    url: site.attributes.url,
    site,
  });

  storeApiDetails(site);
  setupAxiosForApi(site.attributes.url, site.attributes['auth-url']);
};

export const clearApi = site => dispatch => {
  dispatch({
    type: API_CLEARED,
  });

  clearApiDetails();
};
